import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Inventory & Warehouses sub-navigation: the master data (Items MD-03,
 * Categories MD-04, Units MD-12, Price Tiers MD-14) followed by the stock
 * core the second wave shipped — balances (INV-05), the ledger (INV-06),
 * locations (MD-08/INV-04), vouchers (INV-08), stock takes (INV-05 §5.7) and
 * transfers (INV-07).
 */
const TABS = [
  { to: '/inventory', end: true, key: 'inv.tabItems' },
  { to: '/inventory/categories', end: false, key: 'inv.tabCategories' },
  { to: '/inventory/units', end: false, key: 'inv.tabUnits' },
  { to: '/inventory/tiers', end: false, key: 'inv.tabTiers' },
  { to: '/inventory/manufacturers', end: false, key: 'inv.tabManufacturers' },
  { to: '/inventory/stock', end: false, key: 'inv.tabStock' },
  { to: '/inventory/movements', end: false, key: 'inv.tabMovements' },
  { to: '/inventory/warehouses', end: false, key: 'inv.tabWarehouses' },
  { to: '/inventory/adjustments', end: false, key: 'inv.tabAdjustments' },
  { to: '/inventory/counts', end: false, key: 'inv.tabCounts' },
  { to: '/inventory/transfers', end: false, key: 'inv.tabTransfers' },
] as const;

export function InventoryTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navInventory')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
